<template>
  <span class="price text-no-wrap">$ {{formatted}} <small v-if="showGst"> + GST</small></span>
</template>

<script>
export default {
  name: "Price",
  props: {
    price: {
      required: true,
    },
    showGst: {
      default: false
    }
  },
  computed: {
    selectedCurrency() {
      return 'NZD'
    },
    formatted(){
      return (this.priceInCurrency || 0).toLocaleString('en-NZ', {minimumFractionDigits: 0, maximumFractionDigits: 0})
    },
    priceInCurrency(){
      if(!this.price){
        return 0
      }

      // let rate = 1 / this.currencyRates[this.selectedCurrency]

      return Number(this.price)
    }
  }
}
</script>

<style scoped>

</style>
